import { Component, OnInit, Input } from '@angular/core';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { PlanCompensatorioModel } from 'src/app/models/planCompensatorio.model';
import { ConfiguracionCompensacion, ConfiguracionCompensacionPK } from 'src/app/models/configuracionCompensacion.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';

@Component({
    selector: 'app-inscripcion-compensacion',
    templateUrl: './inscripcion-compensacion.component.html'
})
export class InscripcionCompensacionComponent implements OnInit {
    modalOptionsInscripcionCompensacion: any;

    tipoDocumento: string;
    numeroDocumento: string;

    estadosInscripcion: DetalleDominio[];

    plan: PlanCompensatorioModel;
    inscripcion: ConfiguracionCompensacion;

    turnoSeleccionado: any;
    codigoTurnoAnterior: number;
    edicionInscripcion: boolean;
    estadoInscripcion: string;

    constructor(
        private router: Router,
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService) {
    }

    ngOnInit(): void {
        this.modalOptionsInscripcionCompensacion = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_INSCRIPCION_COMPENSACION,
            'SI', 'NO', 'fas fa-save', true, false,
            'Inscribir',
            null, 'btn-secondary');

        this.tipoDocumento = sessionStorage.getItem('tipoDocumento');
        this.numeroDocumento = sessionStorage.getItem('numDocumento');

        this.inscripcion = new ConfiguracionCompensacion();
        this.inscripcion.configuracionCompensacionPK = new ConfiguracionCompensacionPK();
        this.inscripcion.configuracionCompensacionPK.tipoIdFuncionario = this.tipoDocumento;
        this.inscripcion.configuracionCompensacionPK.numeroIdFuncionario = this.numeroDocumento;
        this.inscripcion.estado = DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_PENDIENTE;
        this.inscripcion.horasCompensacion = 0;
        this.inscripcion.horasAjuste = 0;
        this.inscripcion.porcentajeCompensacion = 0;
        this.edicionInscripcion = false;
        this.codigoTurnoAnterior = 0;

        this.obtenerDominio('EstadoInscripcionPlanCompensacion', 'estadosInscripcion');
        this.consultarPlanCompensacionActual();
    }

    /**
     * Método que permite validar la completitud del formulario
     * @function validarFormularioCompleto
     * @author dfranco@asesoftware.com
     */
    public validarFormularioCompleto() {
        const fechaActual: Date = new Date();
        this.modalOptionsInscripcionCompensacion.disabled = !(
            this.utilService.validarCamposObligatorios(this.inscripcion.configuracionCompensacionPK.turnoIdTurno) &&
            this.utilService.validarCamposObligatorios(this.inscripcion.horarioCompensacion) &&
            this.utilService.validarCamposObligatorios(this.inscripcion.observacionesFuncionario) &&
            !(this.inscripcion.estado === DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_APROBADO
                || this.inscripcion.estado === DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_RECHAZADO) &&
            (this.utilService.setearFinFecha(new Date(this.plan.fechaInicialInscripcion)).getTime() <=
            this.utilService.setearFinFecha(fechaActual).getTime()) &&
            (this.utilService.setearFinFecha(new Date(this.plan.fechaFinalInscripcion)).getTime() >= 
            this.utilService.setearFinFecha(fechaActual).getTime()));
    }

    /**
     * Método que permite actualizar el DTO con la opción de turno seleccionada por el usuario
     * @author dfranco@asesoftware.com
     * @function asosciarTurnoAInscripcion
     */
    public asosciarTurnoAInscripcion() {
        if (this.turnoSeleccionado !== undefined) {
            this.inscripcion.configuracionCompensacionPK.turnoIdTurno = this.turnoSeleccionado.idTurno;
        }
    }

    /**
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     * @function obtenerDominio
     * @author dfranco@asesoftware.com
     * @param filtro Dominio a consultar
     * @param lista Variable a la que se va a asignar el resultado
     */
    obtenerDominio(filtro, lista) {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', filtro]);
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
        this.global.getGenerico(url).subscribe(
            data => {
                this[lista] = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    /**
     * Método que permite consultar el plan de compensación activo o actual
     * @function consultarPlanCompensacionActual
     * @author dfranco@asesoftware.com
     */
    public consultarPlanCompensacionActual() {
        this.spinner.show();
        const serviceProvider = 'consultarCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=estado', DominiosService.ESTADO_PLAN_COMPENSACION_ACTIVO]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                const fechaActual: Date = new Date();
                if (data.length > 0) {
                    this.plan = data[0];
                    this.consultarTurnosPlanCompensacionActual();
                    if (this.utilService.setearFinFecha((new Date(this.plan.fechaInicialInscripcion))).getTime() > 
                    this.utilService.setearFinFecha(fechaActual).getTime() ||
                    (this.utilService.setearFinFecha(new Date(this.plan.fechaFinalInscripcion))).getTime() < 
                    this.utilService.setearFinFecha(fechaActual).getTime()) {
                        this.alertService.generateAlertError(ConstantesService.MENSAJE_NO_EXISTE_PLAN_COMPENSACION, '');
                    }
                } else {
                    this.alertService.generateAlertError(ConstantesService.MENSAJE_NO_EXISTE_PLAN_COMPENSACION, '');
                }
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar los turnos parametrizados en el plan de compensación actual
     * @author dfranco@asesoftware.com
     * @function consultarTurnosPlanCompensacionActual
     */
    public consultarTurnosPlanCompensacionActual() {
        this.spinner.show();
        const serviceProvider = 'consultarTurnosCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy',
            this.urlService.encodeURI('idPlanCompensacion=' + this.plan.idPlanCompensacion.toString() + '&estado=ACT')]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.plan.listaTurnos = data;
                this.consultarInscripcionFuncionario();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar inscripción del funcionario a plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar la inscripción del formulario al plan de compensación actual
     * @function consultarInscripcionFuncionario
     * @author dfranco@asesoftware.com
     */
    public consultarInscripcionFuncionario() {
        this.spinner.show();
        const serviceProvider = 'validarInscripcionPlanActual';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.tipoDocumento]);
        queryParams.push(['numeroDocumento', this.numeroDocumento]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data) {
                    this.inscripcion = data;
                    this.codigoTurnoAnterior = this.inscripcion.configuracionCompensacionPK.turnoIdTurno;
                    this.edicionInscripcion = true;
                    const turnoEncontrado = this.plan.listaTurnos.filter(
                        turno => turno.idTurno === this.inscripcion.configuracionCompensacionPK.turnoIdTurno);
                    if (turnoEncontrado !== undefined && turnoEncontrado.length > 0) {
                        this.turnoSeleccionado = turnoEncontrado[0];
                    }
                    if (this.inscripcion.estado === DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_APROBADO
                        || this.inscripcion.estado === DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_RECHAZADO) {
                        this.alertService.generateAlertError(ConstantesService.MENSAJE_INSCRIPCION_PLAN_COMENSACION_FINAL, '');
                    }
                    this.validarFormularioCompleto();
                }
                if (this.estadosInscripcion !== undefined) {
                    const estadosFiltrados = this.estadosInscripcion.filter(
                        estado => estado.detalleDominioPK.nombreDetalleDominio === this.inscripcion.estado);
                    if (estadosFiltrados.length > 0) {
                        this.estadoInscripcion = estadosFiltrados[0].valor;
                    }
                }
                this.spinner.hide();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar inscripción del funcionario a plan de compensación actual');
                }
            }
        );
    }

    /**
     * @function inscrbirCompensacion
     * @author dfranco@asesoftware.com
     * @param  event: any[] Elemento que contiene decisión del usuario para realizar acción
     */
    public inscrbirCompensacion(event: any[]) {
        if (event[0]) {
            this.spinner.show();
            let serviceProvider = '';
            let url = '';
            if (this.edicionInscripcion) {
                serviceProvider = 'editarInscripcionCompensacion';
                const queryParams: Array<[string, string]> = new Array<[string, string]>();
                queryParams.push(['turnoAnterior', this.codigoTurnoAnterior.toString()]);
                url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
                this.urlService.hostAPI_FUNCIONARIOS);
            } else {
                serviceProvider = 'inscripcionCompensacion';
                url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
                    this.urlService.hostAPI_FUNCIONARIOS);
            }
            this.global.postGenerico(url, this.inscripcion).subscribe(
                data => {
                    this.spinner.hide();
                    this.alertService.generateAlertSuccess(
                        ConstantesService.MENSAJE_EXITO_INSCRIPCION_COMPENSACION, '');
                    this.consultarInscripcionFuncionario();
                }, err => {
                    if (err.status === '500') {
                        this.catchException(err.error.message);
                    } else {
                        this.catchException(ConstantesService.MENSAJE_ERROR_INSCRIPCION_COMPENSACION);
                    }
                }
            );
        }
    }

    /**
     * Método de control de Excepciones
     * @function cathException
     * @author dfranco@asesoftware.com
     * @param  error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }
}